import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './NumberStepProgress.css';
function NumberStepProgress({ steps, rtl }) {
    const dir = rtl ? 'progress-right' : 'progress-left';
    const width = `${100 / steps.length}%`;
    return (_jsx("div", Object.assign({ className: 'storybook__numberProgress' }, { children: _jsx("ul", Object.assign({ className: `progressbar ${dir}` }, { children: steps.map((step, i) => {
                return (_jsx("li", Object.assign({ style: { width }, className: step.stepcheck ? "active progress-node" : "progress-node" }, { children: _jsxs("div", Object.assign({ className: 'step-label' }, { children: [_jsx("p", { children: step.label }), step.date && _jsx("span", Object.assign({ className: 'progress-date' }, { children: step.date }))] })) }), step.label + i));
            }) })) })));
}
export default NumberStepProgress;
